<template>
	<div class="card">
		<div class="header">
			<h3>{{ cardTitle }}</h3>
		</div>
		<AnnualReviewStatus :annualReview="details" @reloadAnnualReviewAsync="onReloadAnnualReviewAsync" />
		<PermissionsWrapper :permissionIds="[Permissions.AnnualReview]" :permissionLevel="PermissionLevels.Update">
			<div class="item" v-if="showOverride">
				<span class="label">Override</span>
				<a class="value action" @click="openOverrideModal"> {{ overrideLabel }} </a>
			</div>
		</PermissionsWrapper>
		<div class="item" v-if="applicationUrl && referenceId">
			<span class="label">View Application</span>
			<a class="value action" :href="applicationUrl" target="_blank"> {{ referenceId }} </a>
		</div>

		<OverrideModal
			v-if="viewingOverride"
			:annualReviewId="details.id"
			:loanId="details.loanId"
			:overrides="details.annualReviewOverrides"
			:creditPullTypeId="creditPullTypeId"
			@overrideSuccessAsync="onReloadAnnualReviewAsync"
			@close="closeOverrideModal" />
	</div>
</template>

<script setup lang="ts">
	import { ref, computed } from 'vue';
	import { AnnualReviewDetails } from '@/models/loans';
	import { AnnualReviewStatusTypes } from '@/types/annual-review';
	import OverrideModal from '@/components/loan/annual-review/OverrideModal.vue';
	import AnnualReviewStatus from '@/components/loan/annual-review/AnnualReviewStatus.vue';
	import PermissionsWrapper from '@/components/wrappers/PermissionsWrapper.vue';
	import { Permissions, PermissionLevels } from '@/models/permissions';

	const props = defineProps<{
		cardTitle: string;
		referenceId: string;
		applicationUrl: string;
		details: AnnualReviewDetails;
		creditPullTypeId: number;
		onReloadAnnualReviewAsync: () => Promise<void>;
	}>();

	const viewingOverride = ref(false);

	const closeOverrideModal = () => (viewingOverride.value = false);
	const openOverrideModal = () => (viewingOverride.value = true);

	const overrideLabel = computed(() =>
		props.details.annualReviewOverrides.length > 0 ? 'View Override' : '+ Add Override'
	);

	const showOverride = computed(() => {
		const validStatuses = [AnnualReviewStatusTypes.INITIALLY_FAILED, AnnualReviewStatusTypes.DECLINED];

		const inValidStatus = validStatuses.includes(props.details.annualReviewStatusId);
		const existingOverride = props.details.annualReviewOverrides.length > 0;

		return inValidStatus || existingOverride;
	});
</script>

<style scoped src="@/assets/css/card-rizz.css" />